<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-cfs"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new cfs</small
                >
              </legend>
              <form @submit.prevent="newCfs()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>cfs name</label>
                      <input
                        type="text"
                        class="form-control cfs_name"
                        placeholder="cfs /location name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingCfs"
                >
                  <i class="fa fa-plus"></i> Add cfs
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingCfsLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-destination"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new destination</small
                >
              </legend>
              <form @submit.prevent="newDestination()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>destination name</label>
                      <input
                        type="text"
                        class="form-control destination_name"
                        placeholder="destination name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingDestination"
                >
                  <i class="fa fa-plus"></i> Add destination
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingDestinationLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-driver"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new driver</small
                >
              </legend>
              <form @submit.prevent="newDriver()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>driver name</label>
                      <input
                        type="text"
                        class="form-control drivers_name"
                        placeholder="drivers name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ID/Passport no</label>
                      <input
                        type="text"
                        class="form-control id_passport_no"
                        placeholder="destination name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number kenya</label>
                      <input
                        type="text"
                        class="form-control phone_number_ke"
                        placeholder="phone number kenya"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number Sudan</label>
                      <input
                        type="text"
                        class="form-control phone_number_su"
                        placeholder="phone number sudan"
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingDriver"
                >
                  <i class="fa fa-plus"></i> Add driver
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingDriverLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New mileage</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-cfs"
              >
                <i class="fa fa-plus"></i> new cfs
              </button>
              <p></p>
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-destination"
              >
                <i class="fa fa-plus"></i> new destination
              </button>
              <p></p>
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-driver"
              >
                <i class="fa fa-plus"></i> new driver
              </button>
              <p></p>
              <div>
                <form @submit.prevent="newMileage()">
                  <div class="row">
                    <div class="col-md-6">
                      <label>Invoice no</label>
                      <input
                        type="text"
                        class="form-control invoice_no input-rounded f-s-14"
                        required
                      />
                    </div>
                    <div class="col-md-6">
                      <label>Date</label>
                      <input
                        type="date"
                        class="form-control mileage_date input-rounded f-s-14"
                        required
                      />
                    </div>
                  </div>
                  <div></div>
                  <p></p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive" width="100">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Driver</th>
                              <th>Truck</th>
                              <th>Amount(USD)</th>
                              <th>Turn boy</th>
                              <th>Total(USD)</th>
                              <th>Consignee</th>
                              <th>CFS</th>
                              <th>Destination</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(mileage_item, k) in mileageItemsrows"
                              :key="k"
                            >
                              <td scope="row">
                                <button
                                  type="button"
                                  class="btn btn-raised btn-raised-danger btn-sm m-1"
                                  @click="deleteRow(k, mileage_item)"
                                >
                                <i class="nav-icon i-Close-Window font-weight-bold"></i>
                                </button>
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemDrivers"
                                  v-model="mileage_item.driver_id"
                                  option-value="id"
                                  option-text="drivers_name"
                                  placeholder="select drivers name"
                                ></model-list-select>
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemTrucks"
                                  v-model="mileage_item.truck_id"
                                  option-value="id"
                                  option-text="truck_no"
                                  placeholder="select truck name"
                                ></model-list-select>
                              </td>
                              <td>
                                <input
                                  class="form-control"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  v-model="mileage_item.mileage_amount"
                                  @wheel="$event.target.blur()"
                                  @keyup="calculateLineTotal(mileage_item)"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="mileage_item.turn_boy"
                                />
                              </td>

                              <td>
                                <input
                                  readonly
                                  class="form-control text-right"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  v-model="mileage_item.total_price"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="mileage_item.consignment"
                                  required
                                />
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemCfss"
                                  v-model="mileage_item.location_id"
                                  option-value="id"
                                  option-text="cfs_name"
                                  placeholder="select cfs"
                                ></model-list-select>
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemDestinations"
                                  v-model="mileage_item.destination_id"
                                  option-value="id"
                                  option-text="destination_name"
                                  placeholder="select destination"
                                ></model-list-select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="mileage_item.remark"
                                />
                              </td>
                            </tr>
                            <tr v-show="mileageItemsrows.length === 0">
                              <td colspan="4">
                                <p class="text-center alert-danger p-2">
                                  No products added/available.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="5" class="text-right">Sub Total</td>
                              <input
                                readonly
                                class="form-control text-right sub_total"
                                type="number"
                                min="1"
                                step=".01"
                                :value="invoice_subtotal"
                              />
                            </tr>
                            <tr>
                              <td colspan="5" class="text-right">Total</td>
                              <input
                                readonly
                                class="form-control text-right grand_total"
                                type="number"
                                min="1"
                                step=".01"
                                :value="invoice_total"
                              />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="button"
                        class="btn btn-info addRow"
                        @click="addMileageItems"
                      >
                        <i class="fa fa-plus-circle"></i>
                        Add
                      </button>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingMileage btn-rounded"
                    >
                      <i class="fa fa-plus"></i> create mileage
                    </button>
                    <button
                      type="button"
                      class="btn-rounded btn-flat creatingMileageLoader btn-rounded"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModelListSelect } from "vue-search-select";
import router from "../router/index";
import Vue from "vue";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    this.loadTrucks();
    this.loadCfs();
    this.loadDestinations();
    this.loadPettycashes();
    this.loadDrivers();
  },
  computed: {
    ...mapGetters([
      "systemTrucks",
      "mileageItemsrows",
      "systemCfss",
      "systemDestinations",
      "systemPetty",
      "systemDrivers",
    ]),
  },

  methods: {
    ...mapActions([
      "loadTrucks",
      "newMileage",
      "loadCfs",
      "newCfs",
      "loadDestinations",
      "newDestination",
      "loadPettycashes",
      "loadDrivers",
      "newDriver",
    ]),
    ...mapMutations(["addMileageItems"]),
    calculateTotal() {
      var subtotal, total, totals, balance;
      subtotal = this.mileageItemsrows.reduce(function (sum, mileage_item) {
        var lineTotal = parseFloat(mileage_item.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      balance = this.$store.getters.systemPetty.balance_amount;
      console.log(balance);
      if (total > balance) {
        Vue.swal.fire({
          title: "PETTY CASH BALANCE (USD)",
          text:
            "Kindl note the grand total is greater than the petty cash balance for (USD), this is the remaining balance " +
            balance,
          type: "warning",
        });
        $(".addRow").attr("disabled", true);
        $(".creatingMileage").attr("disabled", true);
      } else {
        $(".addRow").attr("disabled", false);
        $(".creatingMileage").attr("disabled", false);
      }
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(mileage_item) {
      var total = parseFloat(mileage_item.mileage_amount) * parseFloat(1);
      if (!isNaN(total)) {
        mileage_item.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, mileage_item) {
      var idx = this.mileageItemsrows.indexOf(mileage_item);
      console.log(idx, index);
      if (idx > -1) {
        this.mileageItemsrows.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingMileageLoader {
  display: none;
}
.creatingCfsLoader {
  display: none;
}
.creatingDestinationLoader {
  display: none;
}
.creatingDriverLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/mileages/mileages.vue